<template>
    <v-sheet outlined>
        <v-simple-table>
            <tbody>
                <tr v-for="(d, i) in data" :key="i" v-ripple @click="$router.push(d.to)">
                    <th>{{d.title}}</th>
                </tr>
            </tbody>
        </v-simple-table>
    </v-sheet>
</template>

<script>
export default {
    name: "LinkList",
    props: {
        data: Array
    }
}
</script>

<style>

</style>